module.exports = __webpack_public_path__ + "static/whitetrashtyler-874e52184c9e1f5b9e26eebe1c1739ab.jpg";